import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import "./Login.css";

function Login({ setUser }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("user");
  const navigate = useNavigate();

  // Hardcoded admin credentials
  const ADMIN_EMAIL = "matthewebolton@hotmail.com"; // Replace with your admin email
  const ADMIN_PASSWORD = "television"; // Replace with your admin password

  const handleLogin = () => {
    if (
      email === ADMIN_EMAIL &&
      password === ADMIN_PASSWORD &&
      role === "admin"
    ) {
      // Logging in as Admin
      setUser({ role: "admin", email: email });
      navigate("/admin-dashboard"); // Admin Dashboard route
    } else if (role === "user") {
      // Logging in as User using Firebase Authentication
      const auth = getAuth();
      signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          // Signed in successfully
          const user = userCredential.user;
          setUser({ role: "user", email: user.email });
          navigate("/dashboard"); // Normal user dashboard
        })
        .catch((error) => {
          const errorMessage = error.message;
          alert(`Login failed: ${errorMessage}`);
        });
    } else {
      alert("Invalid credentials");
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Login</h2>
        <div className="input-container">
          <input
            type="text"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="login-input"
          />
        </div>
        <div className="input-container">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="login-input"
          />
        </div>
        <div className="role-selection">
          <label>
            <input
              type="radio"
              value="user"
              checked={role === "user"}
              onChange={() => setRole("user")}
            />
            Regular User
          </label>
          <label>
            <input
              type="radio"
              value="admin"
              checked={role === "admin"}
              onChange={() => setRole("admin")}
            />
            Admin
          </label>
        </div>
        <button onClick={handleLogin} className="login-button">
          Login
        </button>
        <p className="signup-link">
          Don't have an account? <a href="/signup">Create Account</a>
        </p>
      </div>
    </div>
  );
}

export default Login;
